export type AffordableStepKey =
  | "authorizationToAssist"
  | "memberProfiles"
  | "rentalDetails"
  | "studentDetails"
  | "specialNeeds"
  | "specialStatus"
  | "householdIncome"
  | "assets"
  | "financialSummary"
  | "uploadCenter"
  | "reviewSign";

export const STEP_ORDER: AffordableStepKey[] = [
  "authorizationToAssist",
  "memberProfiles",
  "rentalDetails",
  "studentDetails",
  "specialNeeds",
  "specialStatus",
  "householdIncome",
  "assets",
  "financialSummary",
  "uploadCenter",
  "reviewSign",
];

export type ApplicationData = Partial<Record<AffordableStepKey, unknown>> & {
  _updatedAt?: number;
  language?: string;
};

export interface ApplicationRecord {
  id: string;
  propertyId?: string;
  status?: string;
  role?: string;
  applicationData: ApplicationData;
}

export const computeResumePoint = (
  applicationData: ApplicationData
): { completedSteps: number[]; resumeStep: number } => {
  const completedSteps = STEP_ORDER.flatMap((key, idx) =>
    applicationData[key] ? [idx] : []
  );
  const firstIncomplete = STEP_ORDER.findIndex((key) => !applicationData[key]);
  const resumeStep =
    firstIncomplete === -1 ? STEP_ORDER.length - 1 : firstIncomplete;
  return { completedSteps, resumeStep };
};
